import React from "react";
import ReactDOM from "react-dom/client";
import AppRoutes from "./Routes";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import "antd/dist/reset.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppRoutes />);
